const Star = ({ color = "#FFBF51" }) => (
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none">
    <path
      d="M10.3715 1.11193C10.5422 0.700972 11.1244 0.700973 11.2951 1.11193L13.6363 6.74884C13.7083 6.92205 13.8711 7.04044 14.0581 7.05545L20.1364 7.54342C20.5795 7.57899 20.7593 8.13188 20.4219 8.42132L15.7898 12.3947C15.6477 12.5167 15.5856 12.7078 15.629 12.8901L17.044 18.8303C17.147 19.263 16.6762 19.6048 16.2967 19.3727L11.0942 16.1906C10.9341 16.0926 10.7325 16.0926 10.5724 16.1906L5.36992 19.3727C4.99045 19.6048 4.51956 19.263 4.62264 18.8303L6.03762 12.8901C6.08103 12.7078 6.01894 12.5167 5.87677 12.3947L1.24472 8.42132C0.907294 8.13188 1.08711 7.57899 1.53025 7.54342L7.60855 7.05545C7.79551 7.04044 7.95835 6.92205 8.03029 6.74884L10.3715 1.11193Z"
      fill={color}
    />
  </svg>
);

export default Star;
